"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasRenderingContext = void 0;
var RenderingContext_1 = require("./RenderingContext");
var CanvasRenderingContext = /** @class */ (function (_super) {
    __extends(CanvasRenderingContext, _super);
    function CanvasRenderingContext(canvas) {
        var _this = _super.call(this, canvas) || this;
        _this._ctx = canvas.getContext("2d");
        return _this;
    }
    Object.defineProperty(CanvasRenderingContext.prototype, "globalAlpha", {
        get: function () {
            return this._ctx.globalAlpha;
        },
        set: function (alpha) {
            this._ctx.globalAlpha = alpha;
        },
        enumerable: false,
        configurable: true
    });
    CanvasRenderingContext.prototype.restore = function () {
        this._ctx.restore();
    };
    CanvasRenderingContext.prototype.rotate = function (angle) {
        this._ctx.rotate(angle);
    };
    CanvasRenderingContext.prototype.save = function () {
        this._ctx.save();
    };
    CanvasRenderingContext.prototype.scale = function (x, y) {
        this._ctx.scale(x, y);
    };
    CanvasRenderingContext.prototype.translate = function (x, y) {
        this._ctx.translate(x, y);
    };
    CanvasRenderingContext.prototype.getImageData = function (x, y, width, height) {
        return this._ctx.getImageData(x, y, width, height);
    };
    CanvasRenderingContext.prototype.clearRect = function (x, y, width, height) {
        this._ctx.clearRect(x, y, width, height);
    };
    CanvasRenderingContext.prototype.fillRect = function (x, y, width, height) {
        this._ctx.fillRect(x, y, width, height);
    };
    CanvasRenderingContext.prototype.drawSubcanvas = function (subcanvas, x, y) {
        this._ctx.save();
        this._ctx.imageSmoothingEnabled = false;
        this._ctx.drawImage(subcanvas, x, y, subcanvas.width, subcanvas.height);
        this._ctx.restore();
    };
    CanvasRenderingContext.prototype.setLineDash = function (segments) {
        this._ctx.setLineDash(segments);
    };
    CanvasRenderingContext.prototype.strokeRect = function (x, y, width, height) {
        this._ctx.strokeRect(x, y, width, height);
    };
    return CanvasRenderingContext;
}(RenderingContext_1.RenderingContext));
exports.CanvasRenderingContext = CanvasRenderingContext;
//# sourceMappingURL=CanvasRenderingContext.js.map